// extracted by mini-css-extract-plugin
module.exports = {"label":"CardLabel_label__iAM7T","synergy":"CardLabel_synergy__CLCGE","synergyTooltip":"CardLabel_synergyTooltip__FQKYn","synergyTooltipBody":"CardLabel_synergyTooltipBody__PD9k_"};